var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "container" },
    [
      _c(
        "a-modal",
        {
          staticStyle: { top: "100px" },
          attrs: {
            title: _vm.title,
            width: 700,
            visible: _vm.visible,
            confirmLoading: _vm.confirmLoading,
            getContainer: () => _vm.$refs.container,
            maskStyle: { top: "93px", left: "154px" },
            mask: _vm.isDesktop(),
            maskClosable: false,
            cancelText: "取消",
            okText: "保存",
          },
          on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
        },
        [
          _c(
            "a-spin",
            { attrs: { spinning: _vm.confirmLoading } },
            [
              _c("div", { staticClass: "bind-tip" }, [
                _vm._v(
                  "为门店「" +
                    _vm._s(_vm.storeName) +
                    "」绑定收银员，绑定后收银员可在独立收银端使用该门店"
                ),
              ]),
              _c("a-transfer", {
                attrs: {
                  "data-source": _vm.userDataSource,
                  "target-keys": _vm.targetKeys,
                  render: _vm.renderItem,
                  titles: ["未绑定", "已绑定"],
                  "list-style": { width: "250px", height: "320px" },
                  "show-search": "",
                  "filter-option": _vm.filterOption,
                },
                on: { change: _vm.handleTransferChange },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }